import { useAtomValue } from 'jotai'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import CollectionYardTabs from '@/components/collection-yard/tabs'
import { selectedMunicipalityIdAtom } from '@/state'

function CollectionYardsView() {

    const title = 'Sběrné dvory'

    const municipalityId = useAtomValue(selectedMunicipalityIdAtom)

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper noPadding>
                <Box p={2.5}>
                    <Typography variant="h2" component="h1">
                        {title}
                    </Typography>
                </Box>
                {municipalityId ?
                    <CollectionYardTabs />
                    :
                    <Box px={2.5}>
                        Vyberte prosím konkrétní obec výše.
                    </Box>
                }
                
            </CustomPaper>
        </>
    )
}

export default CollectionYardsView
